<template>
    <div class="aspect-ratio-image" :style="style" />
</template>

<script>
    export default {
        props: {
            imageUrl: {
                type: String,
                required: true,
            },
        },
        computed: {
            style: function() {
                return {
                    'background-image': `url(${ this.imageUrl })`,
                };
            },
        },
    };
</script>
